var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11L2 21H21L18.5 11",
    stroke: "#456D64",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15L15.0526 7.18421L14.6682 7.66473C14.2302 8.21222 13.6578 8.63687 13.0068 8.89726C12.0395 9.28418 10.9605 9.28418 9.99316 8.89726C9.34217 8.63687 8.76978 8.21222 8.33179 7.66473L7.94737 7.18421L11.5 15Z",
    fill: "#456D64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6L7.94737 7.18421M16 6L15.0526 7.18421M15.0526 7.18421L11.5 15L7.94737 7.18421M15.0526 7.18421L14.6682 7.66473C14.2302 8.21222 13.6578 8.63687 13.0068 8.89726V8.89726C12.0395 9.28418 10.9605 9.28418 9.99316 8.89726V8.89726C9.34217 8.63687 8.76978 8.21222 8.33179 7.66473L7.94737 7.18421M15.0526 7.18421L15.1934 6.87444C15.9618 5.18396 15.4845 3.18757 14.0344 2.02755V2.02755C12.5527 0.842175 10.4473 0.842175 8.96556 2.02755V2.02755C7.51554 3.18757 7.03816 5.18396 7.80656 6.87444L7.94737 7.18421",
    stroke: "#456D64",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6L16.5 9",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6L7 10.5",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/address_icon.13b41c372f825ef4a2fb38b55a99e96f.svg";
export { ForwardRef as ReactComponent };